export default __webpack_public_path__ + "static/media/image@3x.1a73dbe8.jpg";